<h1 mat-dialog-title>
  {{title | translate}}
</h1>
<div mat-dialog-content>
  <p [innerHtml]="message"
     [ngStyle]="{'color': appearance.dialogs.fontColor}"></p>
</div>
<!-- <div class="layout horizontal space-between middle">
  <div *ngIf="showCancel" mat-dialog-actions align="start">
    <button mat-button [mat-dialog-close]="null">{{'CANCEL' | translate}}</button>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true">{{'YES' | translate}}</button>  
    <button mat-button [mat-dialog-close]="false" cdkFocusInitial>{{'NO' | translate}}</button>
  </div>
</div> -->
<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="true">{{'YES' | translate}}</button>  
  <button mat-button [mat-dialog-close]="false" cdkFocusInitial>{{'NO' | translate}}</button>
</div>
